import { useState } from 'react'

import SaveIcon from '@mui/icons-material/Save'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid'
import Switch from '@mui/material/Switch'
import TextField from '@mui/material/TextField'

import type { Entity } from '@models/Entity'

import { StyledError } from '../../../../theme/components/StyledError'
import { useReviewAssignedBijlageForEntity } from '../../hooks/useReviewAssignedBijlageForEntity'
import type { AssignedBijlage } from '../../types/AssignedBijlage'

interface Props {
  bijlage: AssignedBijlage
  entity: Entity
  onClose: () => void
}

export const Review = ({ bijlage, entity, onClose }: Props) => {
  const { mutate: reviewAssignedBijlageForEntity, error } =
    useReviewAssignedBijlageForEntity()
  const [reden, setReden] = useState('')
  const [errors, setErrors] = useState({})
  const [approved, setApproved] = useState(true)
  const [continued, setContinued] = useState(false)

  const { documentsoort, _id, discipline, canBeContinued } = bijlage

  const onClick = () => {
    if ((!approved && !reden) || (approved && reden)) {
      setErrors({
        redenError: true,
      })
      return
    }

    setErrors({})

    reviewAssignedBijlageForEntity(
      {
        entity,
        id: _id,
        approved,
        reden,
        continued,
      },
      { onSuccess: () => onClose() },
    )
  }

  return (
    <>
      <DialogTitle>
        Beoordelen {`${documentsoort} ${discipline || ''}`}
      </DialogTitle>

      <DialogContent>
        <StyledError error={error} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <FormControl>
              <FormControlLabel
                value={approved}
                control={<Switch checked={approved} />}
                label={`${documentsoort} ${discipline || ''}${
                  approved ? ' goedkeuren' : ' afkeuren'
                }`}
                onChange={() => {
                  setReden('')
                  setErrors((errors) => ({ ...errors, redenError: false }))
                  setApproved(!approved)
                  setContinued(false)
                }}
              />
            </FormControl>
          </Grid>

          {!approved && (
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth>
                <TextField
                  value={reden}
                  multiline
                  rows={6}
                  label={`Reden (${reden.length}/500)`}
                  onChange={(e) => setReden(e.target.value)}
                  required
                  error={errors['redenError']}
                  slotProps={{ htmlInput: { maxLength: 500 } }}
                />
              </FormControl>
            </Grid>
          )}
          {approved && canBeContinued && (
            <Grid size={{ xs: 12 }}>
              <FormControl>
                <FormControlLabel
                  value={continued}
                  control={<Switch checked={continued} />}
                  label={`${bijlage.assignedTo} toewijzen om verder te werken`}
                  onChange={() => {
                    setContinued(!continued)
                  }}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Annuleren</Button>

        <Button onClick={onClick} startIcon={<SaveIcon />} variant="contained">
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
